export default __webpack_public_path__ + "static/media/plans.3f169a0b.svg";